import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Help20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_829)'>
      <path
        d='M10 15.5C10.5523 15.5 11 15.0523 11 14.5C11 13.9477 10.5523 13.5 10 13.5C9.44771 13.5 9 13.9477 9 14.5C9 15.0523 9.44771 15.5 10 15.5Z'
        fill='currentColor'
      />
      <path
        d='M8.25 8C8.25 7.01331 9.02857 6.25 10 6.25C10.9714 6.25 11.75 7.01331 11.75 8C11.75 8.74289 11.3107 9.35361 10.6858 9.61427C10.0651 9.87319 9.25 10.4969 9.25 11.5V12.5H10.75V11.5C10.75 11.2566 11.0749 11.0772 11.2633 10.9987C12.4315 10.5114 13.25 9.3647 13.25 8C13.25 6.17506 11.79 4.75 10 4.75C8.21 4.75 6.75 6.17506 6.75 8H8.25Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.250047 10C0.250047 4.61522 4.61527 0.25 10 0.25C15.3848 0.25 19.75 4.61522 19.75 10C19.75 15.3848 15.3848 19.75 10 19.75H1.00005C0.298871 19.75 -0.0124355 18.8296 0.544765 18.404L2.85779 16.6371C1.24042 14.8972 0.250047 12.5639 0.250047 10ZM10 1.75C5.4437 1.75 1.75005 5.44365 1.75005 10C1.75005 12.4433 2.81122 14.6378 4.50023 16.1495C4.84546 16.4585 4.82351 17.0231 4.45533 17.3043L3.21736 18.25H10C14.5564 18.25 18.25 14.5563 18.25 10C18.25 5.44365 14.5564 1.75 10 1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_829'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Help20.displayName = 'Help20';
export default Help20;
